export default "__VITE_ASSET__CKucmquk__"